import { Provider } from 'mobx-react';
import React from 'react';

import OverlayStore from '../stores/OverlayStore';
import PhysicalAnalysisStore from '../stores/PhysicalAnalysisStore';

import PhysicalAnalysisComponent, {
  Validations,
} from '../components/forms/lot/PhysicalAnalysisComponent';
import { ReasonGet } from 'types/model/reason';
import IPhysicalAnalysis from 'types/model/IPhysicalAnalysis';
import { PhysicalAnalysisFailures } from 'types/model/IPhysicalAnalysisFailure';

export interface PhysicalAnalysisContainerProps {
  physicalAnalysis: IPhysicalAnalysis;
  exportSize: number;
  sumTolerance: number;
  reasons: ReasonGet[];
  // PLA-1077: los limites del asistente traen min, unidad y overridable ademas de max;
  // la pantalla de muestras sueltas sigue mandando solo max.
  validations: Validations;
  // PLA-1077. Por defecto false: la pantalla de muestras sueltas no lo pasa y renderiza
  // el formulario de una sola pagina, igual que antes del ticket.
  wizard?: boolean;
  identifier?: string;
  // Parametros incumplidos segun el servidor (ver PhysicalAnalysisComponent).
  failures?: string[];
  // PLA-1077 v2: el porque de cada falla, para el (i) del cierre.
  failureDetails?: PhysicalAnalysisFailures;
}

const PhysicalAnalysisContainer = ({
  physicalAnalysis,
  exportSize,
  sumTolerance,
  ...props
}: PhysicalAnalysisContainerProps) => {
  return (
    <Provider
      overlayStore={new OverlayStore()}
      physicalAnalysisStore={
        new PhysicalAnalysisStore(physicalAnalysis, exportSize, sumTolerance)
      }
    >
      <PhysicalAnalysisComponent {...props} />
    </Provider>
  );
};

export default PhysicalAnalysisContainer;
